import browse from './browse.vue';
import form from './form.vue';
import overrides from './overrides';
import read from './read.vue';
import respondents from './respondents';
import securables from './securables';
import sessions from './sessions';
import submissions from './submissions';
import tasks from './tasks';

export default {
  browse,
  create: form,
  read,
  edit: form,
  overrides,
  respondents,
  sessions,
  submissions,
  securables,
  tasks,
};
